export default __webpack_public_path__ + "static/media/polygonscan.30b354a7.svg";